var $ = require('jquery');

var $header = $('#header');
// Nav Toggle Button
$('#toggle').on('click', function(){
    $header.toggleClass('is-open');
});